import { Await } from "react-router";
import { NewsletterArchiveContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import PropertyInsightArchivePageContent from "@pages/Newsletter/Archive/PropertyInsight/PropertyInsightArchivePageContent";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

export default function NewsletterPropertyInsightArchivePage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<NewsletterArchiveContext, string>>();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (context && !context.payload) {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: NewsletterArchiveContext) => {
        if (kind !== "newsletter") {
          // Error or kind is not "newsletter"
          return <CustomError statusCode={context.statusCode} />;
        }

        // StatusCode is 200 and kind is "newsletter"
        return <PropertyInsightArchivePageContent data={data} />;
      }}
    </Await>
  );
}
